import { sortOption, SORTS } from "@/components/browse/browseSortOptions";
import { MenuPill } from "@/components/filters/MenuPill";
import type { BrowseSort } from "@/lib/browse/browseFilter";

/**
 * Browse's sort on every platform: the shared `MenuPill` ("Sort: Recently added"), as inventory and
 * labels sort.
 *
 * It replaced a native iOS menu and a field-shaped trigger elsewhere, so both storefronts now sort
 * the way the rest of the app does. The e2e specs address options by their `a11y` strings.
 */
export function BrowseSortControl(
  { sort, onChange }: { sort: BrowseSort; onChange: (s: BrowseSort) => void; },
) {
  const selected = sortOption(sort);
  return (
    <MenuPill
      testID="browse-sort-control"
      label={selected.label}
      a11yLabel={`Sort, ${selected.label}`}
      title="Sort cards"
      value={sort}
      onPick={onChange}
      options={SORTS.map((option) => ({
        value: option.value,
        label: option.label,
        a11yLabel: option.a11y,
        testID: `browse-sort-${option.value}`,
      }))}
    />
  );
}
